import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';

import { Subject } from 'rxjs/Rx';
declare var $: any;
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailReminderService } from 'src/app/services/email-reminder.service';
import { TaskService } from 'src/app/services/task.service';
import { EmailIds } from 'src/app/helpers/emailId';
import { ProtectedFileService } from 'src/app/services/protected-file.service';
@Component({
  selector: 'app-email-reminder',
  templateUrl: './email-reminder.component.html',
  styleUrls: ['./email-reminder.component.css']
})
export class EmailReminderComponent implements OnInit {

  dtOptions: any;
  missingBodyKeywords: string;
  missingSubjectKeywords: string;
  dtElement: DataTableDirective;
  error: any = { isError: false, errorMessage: '' };
  dtTrigger: Subject<any> = new Subject();
  reminders: any[];
  reminderMasterForm: FormGroup;
  emailReminderId: string;
  companyId: string;
  mailReminderStaticID: string;
  isDefault: boolean;
  disable: boolean;
  keywordsMissingBodyAlert: boolean;
  keywordsMissingSubjectAlert: boolean;
  aryBodyKeyWords: any[];
  arySubjectKeyWords: any[];
  bodyKeyWords: string;
  subjectKeyWords: string;
  usersKey: any;
  ToEmails: any;
  CcEmails: any;
  ToEmailsVal: any;
  CcEmailsVal: any;
  IsUpsiEmail: boolean;
  filesToUpload: any;
  DocumentFileDoc: any;
  FileNameO: any;
  isFileDeleted: any;
  PasswordProtected: boolean;
  disabledOnclick: boolean = false;
  downloadURLForUPSI: any = environment.pssServerUrl + "upsi/EmailDoc/";
  IsSubjectKeyWordRequired: boolean;
  IsBodyKeyWordRequired: boolean;
  type: any;
  environmentService: any;
  
  constructor(private emailReminderService: EmailReminderService,
    private protectedFileService: ProtectedFileService,
    private alert: AlertComponent,
    private taskService: TaskService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) { }
  noSpecialCharactersValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value && /[!@#$%^&*,.?"'<>+=]/.test(value)) {
      // Return an error if special characters are found
      return { 'noSpecialCharacters': true };
    }
    // No special characters, validation passes
    return null;
  }
  checKkeyWordsAlert() {
    this.disabledOnclick = true;
    console.log(" $('.emailCC').val()", $('.emailCC').val())
    this.noSpecialCharactersValidator(this.reminderMasterForm);
    if ($('.emailCC').val() != undefined && $('.emailCC').val() != '') {
      this.CcEmails = $('.emailCC').val().split(",");
    } else {
      if (this.emailReminderId == EmailIds.getEmailtemplate.EmailForAddedRecipient.emailtemplateId) {
        this.CcEmails = ['Data entry person', 'UPSI All data',]
      } else if (this.emailReminderId == EmailIds.getEmailtemplate.EmailForAddedUPSI.emailtemplateId) {
        this.CcEmails = ['Sharer', 'Data entry person', 'UPSI All data',]
      } else {
        this.CcEmails = ['Data entry person']
      }

    }

    console.log("this.CcEmails", this.CcEmails)


    if ($('.emailTo').val() != undefined && $('.emailTo').val() != '') {
      this.ToEmails = $('.emailTo').val().split(",");
    } else {
      if (this.emailReminderId == EmailIds.getEmailtemplate.EmailForAddedRecipient.emailtemplateId) {
        this.ToEmails = ['Recipient']
      } else if (this.emailReminderId == EmailIds.getEmailtemplate.EmailForAddedUPSI.emailtemplateId) {
        this.ToEmails = ['Recipient']
      } else {
        this.ToEmails = ['UPSI All data']
      }
    }

    console.log("this.emailTo", this.ToEmails)

    this.keywordsMissingSubjectAlert = false;
    this.keywordsMissingBodyAlert = false;
    this.missingSubjectKeywords = "";
    this.missingBodyKeywords = "";
    //check wether Body key word required or not
    if (this.IsBodyKeyWordRequired || this.IsBodyKeyWordRequired == undefined) {
      this.aryBodyKeyWords = (this.bodyKeyWords).split(',');
      var bodyData = $('.summernote').summernote('code');
      for (var i = 0; i < this.aryBodyKeyWords.length; i++) {
        if (!(bodyData.indexOf(this.aryBodyKeyWords[i]) > -1)) {
          this.keywordsMissingBodyAlert = true;
          if (this.missingBodyKeywords == "")
            this.missingBodyKeywords = this.aryBodyKeyWords[i];
          else
            this.missingBodyKeywords = this.missingBodyKeywords + ',' + this.aryBodyKeyWords[i];
        }
      }
    }
    //check wether Subject key word required or not
    if (this.IsSubjectKeyWordRequired || this.IsSubjectKeyWordRequired == undefined) {
      this.arySubjectKeyWords = (this.subjectKeyWords).split(',');
      var subjectData = this.reminderMasterForm.controls.Subject.value;
      for (var i = 0; i < this.arySubjectKeyWords.length; i++) {
        if (!(subjectData.indexOf(this.arySubjectKeyWords[i]) > -1)) {
          this.keywordsMissingSubjectAlert = true;
          if (this.missingSubjectKeywords == "")
            this.missingSubjectKeywords = this.arySubjectKeyWords[i];
          else
            this.missingSubjectKeywords = this.missingSubjectKeywords + ',' + this.arySubjectKeyWords[i];
        }
      }
    }
    console.log('!this.keywordsMissingSubjectAlert && !this.keywordsMissingBodyAlert', !this.keywordsMissingSubjectAlert && !this.keywordsMissingBodyAlert)
    if (!this.keywordsMissingSubjectAlert && !this.keywordsMissingBodyAlert) {
      this.editReminder();
    }
    else {
      this.disabledOnclick = false;
      $('#confirmation').modal('toggle');
    }
  }

  editReminder() {
    //var loginUsers = JSON.parse(localStorage.getItem("user"));
    var date = new Date();
    var timestamp = date.getTime();
    var updatedEmailRemnder = {
      MailReminderStaticID: this.mailReminderStaticID,
      BodyKeyWords: this.bodyKeyWords,
      SubjectKeyWords: this.subjectKeyWords,
      _id: this.emailReminderId,
      CompanyID: this.companyId,
      Body: $('.summernote').summernote('code'),
      Title: this.reminderMasterForm.controls.Title.value,
      Subject: this.reminderMasterForm.controls.Subject.value,
      IsDefault: this.isDefault,
      CcEmails: this.CcEmails,
      ToEmails: this.ToEmails,
      EmailText: this.reminderMasterForm.controls.EmailText.value,
      FileNameUq: (this.filesToUpload) ? timestamp + "-" + this.filesToUpload.name.replace(',', '') : null
      //CreatedBy: loginUsers._id
    }

    if (!this.filesToUpload) {
      delete updatedEmailRemnder.FileNameUq;
    }

    if (this.isFileDeleted) {
      updatedEmailRemnder.FileNameUq = null
    }


    if (!this.isDefault) {
      this.emailReminderService.updateEmailReminder(updatedEmailRemnder)
        .subscribe(emailReminder => {
          this.disabledOnclick = false;
          if (emailReminder.status == 0) {
            $('#reminderDialog').modal('toggle');
            $('.summernote').summernote('code', "")
            if (this.filesToUpload) {
              console.log("this.filesToUpload", this.filesToUpload)
              this.makeFileRequest(environment.pssServerUrl + "upsi/EmailAttachment/" + this.emailReminderId, timestamp, [this.filesToUpload], 'UPSI')
            }
            this.alert.success(emailReminder.message);
            this.reminderMasterForm.reset();
          } else {
            $('#reminderDialog').modal('toggle');
            this.alert.error(emailReminder.message);
          }
          this.getReminderList(this.type);
        });
    }
    else {
      this.emailReminderService.addEmailReminder(updatedEmailRemnder)
        .subscribe(emailReminder => {
          this.disabledOnclick = false;
          if (emailReminder.status == 0) {

            $('#reminderDialog').modal('toggle');
            $('.summernote').summernote('code', "")
            this.alert.success(emailReminder.message);
            this.reminderMasterForm.reset();
          } else {
            $('#reminderDialog').modal('toggle');
            this.alert.error(emailReminder.message);
          }
          this.getReminderList(this.type);
        });
    }
  }
  fileChanged($event) {
    console.log('file changed', $event.target.files[0])
    this.filesToUpload = $event.target.files[0];
    console.log("this.filesToUpload", this.filesToUpload)

  }
  deleteFile() {

    this.DocumentFileDoc = false;
    this.isFileDeleted = true;
    this.filesToUpload = false;
  }

  downloadFile() {

    console.log('downloadURLForUPSI', this.downloadURLForUPSI + this.DocumentFileDoc)
    window.location.href = this.downloadURLForUPSI + this.DocumentFileDoc;
  }

  makeFileRequest(url: string, params: any, files, title: string) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var self = this;
      var xhr = new XMLHttpRequest();
      console.log('files', files)
      for (var i = 0; i < files.length; i++) {
        formData.append("file", files[i], params + "-" + files[i].name.replace(',', ''));
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.setRequestHeader('userdetail', this.getUserDetail())
      xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))
      xhr.send(formData);
    });
  }
  getUserDetail() {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
    var resourcesData = resources.filter(function (item) {
      return item.Menu === 'UPSI';
    })[0]

    var upsiAdmin;
    if (resourcesData) {
      upsiAdmin = (resourcesData['Menu']) ? true : false
    } else {
      upsiAdmin = false
    }

    var loginUser = {
      id: user._id,
      firstName: user.FirstName,
      lastName: user.LastName,
      upsiAdmin: upsiAdmin,
      EmailId: user.EmailId,
      companyDetails: companyDetails,
      title: user.Title
    }
    return JSON.stringify(loginUser);
  }
  loadEmailReminderToEdit(emailReminderId12) {
  const emailReminderId = [{ emailReminderId: emailReminderId12}, { type: this.type }];
  const encodedEmailReminderId = encodeURIComponent(JSON.stringify(emailReminderId));// Log emailReminderId for debugging
console.log(emailReminderId);

// Construct the route with parameters
const routeSegments = [{ outlets: { 'structure-outlet': ['summernote', encodedEmailReminderId] } }];

// Navigate to the route
this.router.navigate(routeSegments, { relativeTo: this.activatedRoute.parent });
  }


  loadEmailReminderToEdit123(emailReminderId) {
    this.emailReminderService.getEmailReminderById(emailReminderId)
      .subscribe((emailReminders: any) => {


        if (emailReminders.status == 0) {
          $("#reminderTable").DataTable().destroy();
          $('#reminderDialog').modal('toggle');
          this.draggableModelPopup();
          this.usersKey = [
            'Sharer',
            'Recipient',
            'Data entry person',
            'ADMIN',
            'UPSI All data'

          ];
          $('.emailTo').val('');
          $('.emailCC').val('');
          
            $('.emailTo').tagsInput({
              'autocomplete': {
                source: this.usersKey,
                change: function (event, ui) {
                  if (ui.item == null) {
                    console.log('ui.item', ui.item)
                    $(this).val((ui.item ? ui.item.id : ""));
                  }
                }
              },
              'unique': true,
              'interactive': true,
              'width': 'auto',
              'height': 'auto',
              'onAddTag': function (input, value) {

                if (!(/[a-z0-9._%+-]+@[a-z0-9.-]+[.]+[a-z0-9.-]{2,3}/.test(value)) && !['Sharer', 'Recipient', 'Data entry person', 'ADMIN', 'UPSI All data', 'Other'].includes(value)) {
                  $('.emailTo').removeTag(value);
                }
                $('.emailCC').removeTag(value);

              }
            })
            $('.emailCC').tagsInput({
              'autocomplete': {
                source: this.usersKey,
                change: function (event, ui) {
                  if (ui.item == null) {
                    $(this).val((ui.item ? ui.item.id : ""));
                  }
                }
              },
              'unique': true,
              'interactive': true,
              'width': 'auto',
              'height': 'auto',
              'onAddTag': function (input, value) {
                if (!(/[a-z0-9._%+-]+@[a-z0-9.-]+[.]+[a-z0-9.-]{2,3}/.test(value)) && !['Sharer', 'Recipient', 'Data entry person', 'ADMIN', 'UPSI All data', 'Other'].includes(value)) {
                  $('.emailCC').removeTag(value);
                }
                $('.emailTo').removeTag(value);
              }
            });
            $('.emailTo').importTags('');
            $('.emailCC').importTags('');
            this.bodyKeyWords = emailReminders.emailReminderData[0].BodyKeyWords;
            this.subjectKeyWords = emailReminders.emailReminderData[0].SubjectKeyWords;
            this.arySubjectKeyWords = (this.subjectKeyWords).split(',');
            this.aryBodyKeyWords = (this.bodyKeyWords).split(',');
            this.mailReminderStaticID = emailReminders.emailReminderData[0].MailReminderStaticID;
            this.emailReminderId = emailReminders.emailReminderData[0]._id;
            this.isDefault = emailReminders.emailReminderData[0].IsDefault;
            this.reminderMasterForm.controls.Title.setValue(emailReminders.emailReminderData[0].Title);
            this.reminderMasterForm.controls.Title.disable();
            this.reminderMasterForm.controls.Title.updateValueAndValidity();
            this.ToEmailsVal = emailReminders.emailReminderData[0].ToEmails.join();
            this.CcEmailsVal = emailReminders.emailReminderData[0].CcEmails.join();
            this.IsSubjectKeyWordRequired = emailReminders.emailReminderData[0].IsSubjectKeyWordRequired;
            this.IsBodyKeyWordRequired = emailReminders.emailReminderData[0].IsBodyKeyWordRequired;
            this.IsUpsiEmail = emailReminders.emailReminderData[0].IsUpsiEmail;
            this.reminderMasterForm.controls.EmailText.setValue(emailReminders.emailReminderData[0].EmailText);
            this.DocumentFileDoc = emailReminders.emailReminderData[0].FileNameUq;
            $(".emailTo").importTags(this.ToEmailsVal);
            $(".emailCC").importTags(this.CcEmailsVal);
            this.FileNameO = (emailReminders.emailReminderData[0].FileNameUq) ? emailReminders.emailReminderData[0].FileNameUq.slice(emailReminders.emailReminderData[0].FileNameUq.indexOf("-") + 1) : ""
            this.reminderMasterForm.controls.Body?.setValue(emailReminders.emailReminderData[0].Body);
            this.reminderMasterForm.controls.Subject?.setValue(emailReminders.emailReminderData[0].Subject);          

            $('#summernote').summernote('code', emailReminders.emailReminderData[0].Body);
           
            $("#reminderModalLabel").html('<i class="fa fa-pencil"></i> Update Email Templates');
            $('#btnsaveReminder').hide();
            $('#btnupdateReminder').show();
            this.error = { isError: false, errorMessage: '' }
         
        }
      });
  }

  

  proceedForUpdate() {
    $('#confirmation').modal('toggle');
    this.editReminder();
  }

  draggableModelPopup() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
  }

  getReminderList(type) {
    // console.log('it is coming here')
    
    $("#reminderTable").DataTable().destroy();
    this.emailReminderService.getEmailReminderList(type)
      .subscribe((reminderList:any) => {
        if (reminderList.status == 0) {
          this.reminders = [];
          this.reminders = reminderList.emailRemindersResult;
          this.dtTrigger.next();
        }
      })
  }

  ChangeAttacmentStatus() {

    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var paramData = {
      companyID: companyDetails.companyID,
      status: this.PasswordProtected
    }

    this.protectedFileService.setAttachmentStatus(paramData).subscribe(response => {

    })
    console.log("PasswordProtected", this.PasswordProtected)
  }


  getAttacmentStatus() {

    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var paramData = {
      companyID: companyDetails.companyID,
    }

    this.protectedFileService.getAttachmentStatus(paramData).subscribe(response => {
      // console.log(response)
      if (response.status == 0) {
        if(response.data.length>0)
        {
           this.PasswordProtected = response.data[0].Status
        }
       
      }
    })
    // console.log("PasswordProtected", this.PasswordProtected)
  }

  ngOnInit() {
    
    this.type = '';
    this.activatedRoute.params.subscribe(params => {
      this.type = params['type']
      this.getReminderList(this.type);
    })
    this.environmentService = environment.Service

    this.getAttacmentStatus()
    $('.summernote').summernote({
      tabsize: 2,
      height: 200
    });
    this.disable = true;
    this.reminderMasterForm = new FormGroup({
      Title: new FormControl('', [Validators.required]),
      Subject: new FormControl('', [Validators.required,this.noSpecialCharactersValidator]),
      EmailText: new FormControl('', [])
    });

    this.dtOptions = {
      destroy: true,
      scrollY: "250px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1, 2] }],
      rowReorder: {
        dataSrc: 'readingOrder',
        select: true,
      },
      select: true,
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Email Templates',
          title: 'Email Templates',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }


        }
      ]
    };

    $("button.note-btn > i.note-icon-code").parent().hide();
    $("button.note-btn > i.note-icon-video").parent().hide();
    $("button.note-btn > i.note-icon-picture").parent().hide();
  }

  intializeDatatable() {
    // this.getReminderList()
    this.getReminderList(this.type);

  }

}

